import { render } from "./DockerAttachAndDetach.vue?vue&type=template&id=ca73217c"
import script from "./DockerAttachAndDetach.vue?vue&type=script&lang=js"
export * from "./DockerAttachAndDetach.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__